module.exports = __webpack_public_path__ + "img/myself03-web.97b34e02.png";